export default __webpack_public_path__ + "static/media/Rubik-MediumItalic.1bc75ab4.ttf";